var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.736 8.92107L5.62503 1.41872C5.43389 1.30726 5.2166 1.24854 4.99534 1.24854C4.77408 1.24854 4.55679 1.30726 4.36565 1.41872C4.17734 1.5267 4.0211 1.68278 3.91293 1.87098C3.80476 2.05918 3.74854 2.27275 3.75003 2.48982V17.5101C3.74941 17.727 3.80636 17.9401 3.91507 18.1277C4.02378 18.3154 4.18035 18.4708 4.36878 18.5781C4.55991 18.6896 4.77721 18.7483 4.99847 18.7483C5.21973 18.7483 5.43702 18.6896 5.62815 18.5781L18.736 11.0781C18.9294 10.972 19.0907 10.8159 19.2031 10.6261C19.3155 10.4363 19.3748 10.2198 19.3748 9.99919C19.3748 9.7786 19.3155 9.56207 19.2031 9.37226C19.0907 9.18245 18.9294 9.02635 18.736 8.92029V8.92107ZM5.00003 16.6148V3.38513L11.6164 9.99997L5.00003 16.6148ZM12.5 10.8836L13.9782 12.3617L7.06409 16.3195L12.5 10.8836ZM7.06253 3.67966L13.9789 7.63825L12.5 9.11638L7.06253 3.67966ZM15.1024 11.7187L13.3836 9.99997L15.1024 8.28122L18.1047 9.99997L15.1024 11.7187Z",
    fill: "#F9F7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/GooglePlayLogo.b221a4bff505cccc16bcbd2f40fc9550.svg";
export { ForwardRef as ReactComponent };